// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {SimUser} from "@models";
import {SimUserService} from "@services";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_AddAdHocUserDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_AddAdHocUserDialogOutput extends MatDialogDataBaseOutput {
	user: SimUser;
}

@Component({
	selector: "sim-add-ad-hoc-user-dialog",
	templateUrl: "./add-ad-hoc-user-dialog.component.html",
	styleUrls: ["./add-ad-hoc-user-dialog.component.scss"],
	standalone: false,
})
export class AddAdHocUserDialogComponent extends BasicMaterialDialog<
	AddAdHocUserDialogComponent,
	DialogData_AddAdHocUserDialogInput,
	DialogData_AddAdHocUserDialogOutput
> {
	T = Translations;
	adHocUserFormGroup = new FormGroup({
		firstNameControl: new FormControl(""),
		lastNameControl: new FormControl(""),
	});

	createUserError: string = null;

	constructor(
		_injector: Injector,
		private _userService: SimUserService,
	) {
		super(_injector);
	}

	createUser() {
		this._userService
			.createAdHocUser({
				firstName: this.adHocUserFormGroup.value.firstNameControl,
				lastName: this.adHocUserFormGroup.value.lastNameControl,
			})
			.then((response) => {
				if (response.success == true) {
					this.close({user: response.user, action: "ok"});
				} else {
					this.createUserError = response.error;
				}
			});
	}
}
